/**
 * A reusable button component matching the designs from Figma
 */
import React from 'react';
import { StyledButton, ButtonText } from './Button.styled';
import Icon from '../Icon/Icon';
import feather from 'feather-icons';
import Loader from '../Loader/Loader';
var noop = function (e) {
    e.preventDefault();
};
export default function Button(_a) {
    var _b, _c;
    var _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.iconRight, iconRight = _e === void 0 ? false : _e, _f = _a.icon, icon = _f === void 0 ? undefined : _f, _g = _a.text, text = _g === void 0 ? undefined : _g, _h = _a.width, width = _h === void 0 ? 'fit-content' : _h, _j = _a.colorVariant, colorVariant = _j === void 0 ? 'dark' : _j, _k = _a.sizeVariant, sizeVariant = _k === void 0 ? 'small' : _k, _l = _a.disabled, disabled = _l === void 0 ? false : _l, _m = _a.onClick, onClick = _m === void 0 ? noop : _m, _o = _a.loading, loading = _o === void 0 ? false : _o;
    var fakeIcon = function (size) { return (React.createElement("div", { style: {
            width: size === 'big' ? '24px' : '16px',
            height: size === 'big' ? '24px' : '16px',
        } })); };
    return (React.createElement(StyledButton, { className: className, width: width, onClick: disabled || loading ? noop : onClick, colorVariant: colorVariant, sizeVariant: sizeVariant, disabled: disabled, iconRight: iconRight, oneItemOnly: (!!text && !icon) || (!text && !!icon) },
        loading ? (React.createElement(Loader, { size: sizeVariant === 'big' ? 'large' : 'medium' })) : !!icon && !!((_b = feather === null || feather === void 0 ? void 0 : feather.icons) === null || _b === void 0 ? void 0 : _b[icon]) ? (React.createElement(Icon, { name: icon, size: sizeVariant === 'big' ? 'large' : 'medium', color: colorVariant === 'light' || colorVariant === 'white' ? 'black' : 'white' })) : null,
        !!text && React.createElement(ButtonText, { colorVariant: colorVariant }, text),
        width !== 'fit-content' &&
            !!text &&
            (loading || (!!icon && !!((_c = feather === null || feather === void 0 ? void 0 : feather.icons) === null || _c === void 0 ? void 0 : _c[icon]))) &&
            fakeIcon(sizeVariant)));
}
